<template>
  <div>
    <chart-card :chart-data="data"
                :chart-options="options"
                :responsive-options="responsiveOptions"
                chartType="Line"
                :render="render">
      <template slot="header">
        <h4 class="card-title">Evolution over time</h4>
        <p class="card-category">{{subtitle}}</p>
      </template>
      <template slot="footer">
        <div class="legend row ml-0">
          <span v-for="company in $store.getters.incentifyers" :key="company.id">
            <i :class="'fas fa-circle ct-legend-'+company.color"/>
            {{company.profile.companyName}}
            &nbsp;
          </span>
        </div>
        <hr>
        <div class="stats">
          <i class="far fa-clock"/> {{subtitle}}
        </div>
      </template>
    </chart-card>
  </div>
</template>

<script>
import {ChartCard} from 'src/components/index'
export default {
  name: 'Payouts-Graph-Multi-View-Card',
  components: {
    ChartCard
  },
  props: {
    render: {type: Boolean, default: false},
    show:   {type: String, default: 'Total'}
  },
  data () {
    return {
      options: {
        //low: 0,
        //high: 1510,
        showArea: false,
        height: '245px',
        axisX: {
          showGrid: false
        },
        lineSmooth: true,
        showLine: true,
        showPoint: true,
        fullWidth: true,
        chartPadding: {
          right: 50
        }
      },
      responsiveOptions: [
        ['screen and (max-width: 640px)', {
          axisX: {
            labelInterpolationFnc: function (value) {
              return value[0]
            }
          }
        }]
      ]
    }
  },
  computed: {
    periodSelected () {
      return this.$store.getters.periodSelected
    },
    subtitle () {
      if (this.periodSelected) {
        return this.$store.getters.periodEvolution.label
      }
      return ''
    },
    lineChart () {
      if (this.$store.getters.payoutsEvolution && this.$store.getters.payoutsEvolution.lineCharts) {
        switch (this.show) {
          case 'Pending':
            return this.$store.getters.payoutsEvolution.lineCharts.pending
          case 'ToSubmit':
            return this.$store.getters.payoutsEvolution.lineCharts.toSubmit
          case 'Submitted':
            return this.$store.getters.payoutsEvolution.lineCharts.submitted
          case 'Paid':
            return this.$store.getters.payoutsEvolution.lineCharts.paid
          case 'Total':
            return this.$store.getters.payoutsEvolution.lineCharts.total
          default:
            console.log('!!! problem with prop show: ', this.show)
            return {}
        }
      }
      else {
        return {}
      }
    },
    data () {
      return this.lineChart ? this.lineChart.data : {}
    },/* 
    options () {
      return this.lineChart.options
    },
    responsiveOptions () {
      return this.lineChart.responsiveOptions
    } */
  }
}
</script>

<style>

</style>